import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "pagination-container" }
const _hoisted_2 = { class: "custom-pagination" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["max"]
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "stat-info" }
const _hoisted_8 = { class: "green" }
const _hoisted_9 = { class: "green" }

import { ref, computed, watch } from 'vue'

// 新增滚动方法
interface PaginationProps {
  total: number
  currentPage: number
  pageSize: number
  pageSizeOptions?: number[]
}

interface PaginationEmits {
  (e: 'update:currentPage', page: number): void
  (e: 'update:pageSize', size: number): void
  (e: 'change', page: number, size: number): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomPagination',
  props: {
    total: {},
    currentPage: {},
    pageSize: {},
    pageSizeOptions: { default: () => [10, 20, 40, 60, 80] }
  },
  emits: ["update:currentPage", "update:pageSize", "change"],
  setup(__props: any, { emit: __emit }) {

const scrollToTop = () => {
  // 方案1：使用平滑滚动到页面顶部
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });

  // 方案2：滚动到自定义容器（如果页面有特定滚动区域）
  const mainContainer = document.querySelector('.el-main');
  if (mainContainer) {
    mainContainer.scrollTop = 0;
  }
};

const props = __props

const emit = __emit

// 内部状态
const gotoPage = ref(props.currentPage)
const internalPageSize = ref(props.pageSize)

// 计算属性
const totalPages = computed(() => Math.ceil(props.total / internalPageSize.value))

const visiblePages = computed(() => {
  const pages = []
  const maxVisible = 5
  let start = Math.max(1, props.currentPage - 2)
  let end = Math.min(totalPages.value, start + maxVisible - 1)
  if (end - start < maxVisible - 1) {
    start = Math.max(1, end - maxVisible + 1)
  }
  for (let i = start; i <= end; i++) {
    pages.push(i)
  }
  return pages
})

const lastPageVisible = computed(() => {
  const v = visiblePages.value
  return v.length ? v[v.length - 1] : 1
})

const showEllipsisAfter = computed(() => {
  return lastPageVisible.value < totalPages.value - 1
})

const showEllipsisBefore = computed(() => {
  return visiblePages.value[0] > 2
})

// 方法
const changePage = (page: number) => {
  if (page < 1 || page > totalPages.value || page === props.currentPage) return
  emit('update:currentPage', page)
  emit('change', page, internalPageSize.value)
  gotoPage.value = page

  scrollToTop(); // 新增滚动调用
}

const handleGotoPage = () => {
  let page = gotoPage.value
  if (!page || page < 1) page = 1
  if (page > totalPages.value) page = totalPages.value
  changePage(page)
}

const handleJump = (direction: 'prev' | 'next') => {
  if (direction === 'prev') {
    const target = Math.max(1, visiblePages.value[0] - 2)
    changePage(target)
  } else {
    const target = Math.min(totalPages.value, visiblePages.value[visiblePages.value.length - 1] + 2)
    changePage(target)
  }
}

const handleSizeChange = (val: string) => {
  const newSize = Number(val)
  internalPageSize.value = newSize
  emit('update:pageSize', newSize)
  emit('update:currentPage', 1)
  emit('change', 1, newSize)
  gotoPage.value = 1
}

// 监听 props 变化，同步内部状态
watch(() => props.currentPage, (newPage) => {
  gotoPage.value = newPage
})

watch(() => props.pageSize, (newSize) => {
  internalPageSize.value = newSize
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "page-btn",
        disabled: _ctx.currentPage === 1,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (changePage(_ctx.currentPage - 1)))
      }, _cache[7] || (_cache[7] = [
        _createElementVNode("span", null, "<", -1)
      ]), 8, _hoisted_3),
      (showEllipsisBefore.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "page-btn ellipsis",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (handleJump('prev')))
          }, "..."))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (page) => {
        return (_openBlock(), _createElementBlock("button", {
          key: page,
          class: _normalizeClass(["page-btn", { active: page === _ctx.currentPage }]),
          onClick: ($event: any) => (changePage(page))
        }, _toDisplayString(page), 11, _hoisted_4))
      }), 128)),
      (showEllipsisAfter.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "page-btn ellipsis",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (handleJump('next')))
          }, "..."))
        : _createCommentVNode("", true),
      (lastPageVisible.value !== totalPages.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: _normalizeClass(["page-btn", { active: totalPages.value === _ctx.currentPage }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (changePage(totalPages.value)))
          }, _toDisplayString(totalPages.value), 3))
        : _createCommentVNode("", true),
      _cache[11] || (_cache[11] = _createElementVNode("span", { class: "goto-label" }, "到", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((gotoPage).value = $event)),
        onKeyup: _withKeys(handleGotoPage, ["enter"]),
        class: "goto-input",
        min: "1",
        max: totalPages.value
      }, null, 40, _hoisted_5), [
        [
          _vModelText,
          gotoPage.value,
          void 0,
          { number: true }
        ]
      ]),
      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "goto-label" }, "页", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((internalPageSize).value = $event)),
        onChange: _cache[6] || (_cache[6] = ($event: any) => (handleSizeChange($event.target.value))),
        class: "size-select"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageSizeOptions, (size) => {
          return (_openBlock(), _createElementBlock("option", {
            key: size,
            value: size
          }, _toDisplayString(size) + "条/页", 9, _hoisted_6))
        }), 128))
      ], 544), [
        [
          _vModelSelect,
          internalPageSize.value,
          void 0,
          { number: true }
        ]
      ]),
      _createElementVNode("span", _hoisted_7, [
        _cache[8] || (_cache[8] = _createTextVNode(" 共 ")),
        _createElementVNode("span", _hoisted_8, _toDisplayString(totalPages.value), 1),
        _cache[9] || (_cache[9] = _createTextVNode(" 页， ")),
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.total), 1),
        _cache[10] || (_cache[10] = _createTextVNode(" 条数据 "))
      ])
    ])
  ]))
}
}

})